export const PASSWORD_CHANGE_INITIALISED = 'PASSWORD_CHANGE_INITIALISED';
export const PASSWORD_CHANGE_CODE_EXPIRED = 'PASSWORD_CHANGE_CODE_EXPIRED';
export const PASSWORD_CHANGED = 'PASSWORD_CHANGED';
export const PASSWORD_CHANGE_FAILED = 'PASSWORD_CHANGE_FAILED';

export const PASSWORD_RESET_AUTH_PROVIDER = {
    legacy: 'legacy',
    betterAuth: 'betterAuth',
};
